import { useContext } from "react";
import { AssessmentSessionContext } from "./AssessmentSessionProvider";
export function useAssessmentSession() {
  const context = useContext(AssessmentSessionContext);
  if (!context) {
    throw new Error("useAssessmentSession must be used within AssessmentSessionProvider");
  }
  return context;
}